import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigateSearchbarParams } from "@app/models/tracking/track-history-param-type";
import { TagModel } from "@interfaces/iTagFilter";
import { AnalyticsTrackingFacadeService } from "@services/analytics-tracking-facade.service";
import { TagviewerComponent } from "../tagviewer/tagviewer.component";

@Component({
    selector: "app-catalog-tagviewer",
    templateUrl: "./catalog-tagviewer.component.html",
    styleUrls: ["./catalog-tagviewer.component.scss"],
    imports: [TagviewerComponent]
})
export class CatalogTagviewerComponent implements OnInit {
	@Output() tagClicked: EventEmitter<TagModel[]> = new EventEmitter<TagModel[]>();
	@Output() resetFilter = new EventEmitter();
	@Input() clickable: boolean;
	@Input() defaultTags: TagModel[];
	@Input() selectedTags: TagModel[];
	@Input() tags: TagModel[];

	constructor(private analyticsTrackingFacadeService: AnalyticsTrackingFacadeService) { }

	ngOnInit() {

	}

	onTagClicked(tag: TagModel) {
		let selectedTags = this.selectedTags;
		if (!selectedTags.find(k => k.id === tag.id)) {
			selectedTags.push(tag);
		} else {
			selectedTags = selectedTags.filter(f => f.id !== tag.id)
		}
		this.analyticsTrackingFacadeService.handleTrackHistory(new NavigateSearchbarParams(false))
		this.tagClicked.emit(selectedTags);
	};

	public get emptySearchResults() {
		return this.defaultTags?.length > 0 && this.tags?.length === 0;
	}
}
